import React from "react";
import { Link } from "react-router-dom";

const FooterBottom = () => {
  return (
    <>
      {/* footer-bottom area start */}
      <div className="footer-bottom-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 text-lg-end text-center">
              <p>کلیه حقوق متعلق به شرکت آسیا سیر ارس می باشد.</p>
            </div>
            <div className="col-lg-6 text-lg-start text-center">
              <div className="copyright-area">
                <p>
                  © 2024 طراحی و توسعه توسط <Link to="https://progrun.ir">ProgRun</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* footer-bottom area end */}
    </>
  );
};

export default FooterBottom;
